import isEqual from 'lodash/isEqual'
import { Coord, DrawItem, Shape } from './types'
import { CreateMapItem } from '../../generated/graphql'

export const toShape = (string: string): Shape => (['poly', 'rect', 'circle'].includes(string)
    ? string as Shape
    : 'poly')

export const flattenCoords = (coords: Coord[]): number[] => (
    coords.flatMap(({ y, x }) => [Math.round(+x), Math.round(+y)])
)

/**
 * cords are in one array like:
 * index 1 = y1
 * index 2 = x1
 * index 3 = y2
 * index 4 = x2
 *
 * And we want to create:
 * index 1 = {y: y1, x: x1} ...
 */
export const nestCoords = (coords: number[]): Coord[] => coords.reduce(
    (arr: Coord[], val, idx) => (!(idx % 2)
        ? [...arr, { x: val, y: coords[idx + 1] }]
        : arr),
    [],
)

export const calculateCenter = (coords: Coord[], scaledFactor = 1) => {
    const xCoords = coords.map((coord) => coord.x * scaledFactor)
    const yCoords = coords.map((coord) => coord.y * scaledFactor)
    return {
        x: (Math.min(...xCoords) + Math.max(...xCoords)) / 2,
        y: (Math.min(...yCoords) + Math.max(...yCoords)) / 2,
    }
}

export const findUpdatedCoordItem = (drawItems: DrawItem[], updatedItems: DrawItem[]) => (
    updatedItems.find((item) => {
        const coordsOfUpdatedItem = flattenCoords(item.coords)
        const drawItem = drawItems.find((e) => e.generatedId === item.generatedId)
        if (!drawItem) {
            return null
        }
        const coordsOfDrawItems = flattenCoords(drawItem.coords)
        return !isEqual(coordsOfUpdatedItem, coordsOfDrawItems)
    })
)

export const convertItemToSubmit = (item: DrawItem, mapId?: number, spaceId?: number): CreateMapItem => ({
    mapId: mapId?.toString(),
    spaceId: spaceId?.toString(),
    shape: item.shape,
    coords: flattenCoords(item.coords),
    name: item.title || 'Untitled'
})

export const createPointForMobile = (item: DrawItem, ref_id: string, mapId?: number, spaceId?: number) => {
    const firstPointFromCoords = {
        x: Math.round(item.coords[0].x), y: Math.round(item.coords[0].y)
    }
    const point = {
        ...item,
        coords: [
            firstPointFromCoords,
        ]
    }
    return {
        ...convertItemToSubmit(point, mapId, spaceId),
        forMobile: true,
        refItemId: ref_id,
    }
}
